import { render, staticRenderFns } from "./ContentSettings.vue?vue&type=template&id=4685833e&scoped=true&"
import script from "./ContentSettings.vue?vue&type=script&lang=js&"
export * from "./ContentSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContentSettings.vue?vue&type=style&index=0&id=4685833e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685833e",
  null
  
)

export default component.exports